let captured = false;
let pendingToken: string | null = null;

// Called before analytics initialize. Fragments keep credentials out of HTTP URL/referrer logs.
export function captureAccountLinkToken() {
    if (captured || window.location.pathname !== "/account-access") return;
    captured = true;
    const candidate = new URLSearchParams(window.location.hash.slice(1)).get("token");
    pendingToken = candidate && /^v1\.[A-Za-z0-9_-]{43}\.[A-Za-z0-9_-]{43}$/.test(candidate) ? candidate : null;
    window.history.replaceState(window.history.state, "", "/account-access");
    const meta = document.createElement("meta"); meta.name = "referrer"; meta.content = "no-referrer"; document.head.appendChild(meta);
}
export function getPendingAccountLinkToken() { return pendingToken; }
export function clearPendingAccountLinkToken() { pendingToken = null; }
export function isAccountLinkSession() { return !!window.sessionStorage.getItem("peeva_account_access_token"); }
